import React from 'react';

import { useUserStore } from 'hooks/UserStoreContext';

import { CommentaireForm } from '../CommentaireForm/CommentaireForm';
import { UserIcon } from '../UserIcon/UserIcon';

import './AjoutCommentaire.less';

interface AjoutCommentaireProps {
  dossierId: string;
}

export const AjoutCommentaire = ({
  dossierId,
}: AjoutCommentaireProps): React.ReactElement => {
  const user = useUserStore();
  const [formulaireIsOpen, setFormulaireIsOpen] =
    React.useState<boolean>(false);

  if (formulaireIsOpen) {
    return (
      <CommentaireForm
        dossierId={dossierId}
        onClose={() => setFormulaireIsOpen(false)}
      />
    );
  }

  return (
    <div className="ajoutCommentaire" onClick={() => setFormulaireIsOpen(true)}>
      <UserIcon
        firstName={user.firstName ?? ''}
        lastName={user.lastName ?? ''}
        profile={user.profile}
      />
      <p className="ajoutCommentaire__placeholder">Ajouter un commentaire...</p>
    </div>
  );
};
